export const FilterTypeTrackingMap = {
  NONE: 'None',
  OBJECT_FILTER: 'ObjectFilter',
  LOCATION_FILTER: 'LocationFilter',
  USER_FILTER: 'UserFilter',
  DATE_FILTER: 'DateFilter',
  SORT: 'Sort',
} as const;
